import { createSelector } from 'reselect';
import { optionsSelector } from './general';

export const userTokenSelector = createSelector(
    optionsSelector,
    options => options.userToken,
);

export const userTypeSelector = createSelector(
    optionsSelector,
    options => options.userType || 'customer',
);
